import { render, staticRenderFns } from "./TransactionsFilter.vue?vue&type=template&id=1b06d8f6&"
import script from "./TransactionsFilter.vue?vue&type=script&lang=js&"
export * from "./TransactionsFilter.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsFilter.vue?vue&type=style&index=0&id=1b06d8f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports